// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// modules
import { combineReducers } from 'redux'
import * as R from 'ramda'
// actions
import {
  SET_LOADED,
  SET_WINDOW_DIMENSION,
  SET_WINDOW_FOCUS,
  SET_PERMISSIONS,
  SET_CONNECTION_STATUS,
  SET_IS_MULTI_TAB,
  SET_SENDFIELD_HEIGHT,
  SET_BROWSER_IS_ONLINE,
  SET_WILL_RECONNECT_IN,
  SET_WORKSPACE_ID,
} from './root.action'
// reducers
import appReducer from '../_app/main/app.reducer'
// setup
import { getState } from '$setup/redux'
import { DEFAULT_WORKSPACE_ID } from '$logic/workspace/constant'

export type ConnectionStatus =
  | 'making ready'
  | 'signing in'
  | 'connecting'
  | 'authenticating'
  | 'updating'
  | 'connected'
  | 'signing out'

interface State {
  connectionStatus: ConnectionStatus
  browserIsOnline: boolean
  willReconnectIn: number
  window: {
    height: number
    width: number
    focus: boolean
  }
  loaded: boolean
  permissions: {
    mic: PermissionState
  }
  isMultiTab: boolean
  sendField: {
    height: number
  }
}

const initialState: State = {
  window: {
    height: 0,
    width: 0,
    focus: true,
  },
  loaded: false,
  permissions: {
    mic: 'prompt',
  },
  connectionStatus: 'making ready',
  browserIsOnline: true,
  willReconnectIn: 0,
  isMultiTab: false,
  sendField: { height: 55 },
  workspaceId: DEFAULT_WORKSPACE_ID,
}

// lens
const loadedLens = R.lensProp('loaded')
const windowLens = R.lensProp('window')
const windowFocusLens = R.lensPath(['window', 'focus'])
const permissionsLens = R.lensProp('permissions')
const connectionStatusLens = R.lensProp('connectionStatus')
const browserIsOnlineLens = R.lensProp('browserIsOnline')
const willReconnectInLens = R.lensProp('willReconnectIn')
const sendFieldHeightLens = R.lensPath(['sendField', 'height'])
const workspaceLens = R.lensPath(['workspaceId'])
// views
export const loadedView = () => R.path(['view', 'main', 'loaded'], getState())
export const isMultiTabView = () =>
  R.path(['view', 'main', 'isMultiTab'], getState())
export const windowView = () => R.path(['view', 'main', 'window'], getState())
export const connectionStatusView = () =>
  R.path(['view', 'main', 'connectionStatus'], getState()) as ConnectionStatus
export const browserIsOnlineView = () =>
  R.path(['view', 'main', 'browserIsOnline'], getState())
export const willReconnectInView = () =>
  R.path(['view', 'main', 'willReconnectIn'], getState())
export const windowFocusView = () =>
  R.path(['view', 'main', 'window', 'focus'], getState())
export const micPermissionView = () =>
  R.path(['view', 'main', 'permissions', 'mic'], getState())
export const sendFieldHeightView = () =>
  R.path(['view', 'main', 'sendField', 'height'], getState())
export const workspaceIdView = () =>
  R.path(['view', 'main', 'workspaceId'], getState())

// reducers
const reducers = {
  [SET_WINDOW_DIMENSION]: (state, { width, height }) =>
    R.set(windowLens, { ...state.window, width, height })(state),

  [SET_WINDOW_FOCUS]: (state, { value }) =>
    R.set(windowFocusLens, value)(state),

  [SET_LOADED]: (state, { loaded }) => R.set(loadedLens, loaded)(state),

  [SET_PERMISSIONS]: (state, value) =>
    R.over(permissionsLens, R.mergeDeepLeft(value), state),

  [SET_CONNECTION_STATUS]: (state, value) => {
    return R.set(connectionStatusLens, value)(state)
  },

  [SET_BROWSER_IS_ONLINE]: (state, value) =>
    R.set(browserIsOnlineLens, value)(state),

  [SET_WILL_RECONNECT_IN]: (state, value) =>
    R.set(willReconnectInLens, value)(state),

  [SET_IS_MULTI_TAB]: (state, value) => ({ ...state, isMultiTab: value }),

  [SET_SENDFIELD_HEIGHT]: (state, height) =>
    R.set(sendFieldHeightLens, height)(state),

  [SET_WORKSPACE_ID]: (state, workspace) =>
    R.set(workspaceLens, workspace)(state),
}

const mainReducer = function reducer(state = initialState, action) {
  return reducers[action.type]
    ? reducers[action.type](state, action.payload)
    : state
}

export default combineReducers({
  main: mainReducer,
  app: appReducer,
})
